import logger from "redux-logger";
import { configureStore } from "@reduxjs/toolkit";

import QuestionTableReducer from "@learningblocks/simulations/shared-components/lib/Questions/QuestionTableRedux/store/reducer";
import { tableQuestionReducer } from "@labxchange/ui-components/lib/TableQuestion/TableQuestionSlice";
import { CSCQReducerNew, MSCQReducerNew } from "@learningblocks/exp-redux";

export const Store = configureStore({
  reducer: {
    questionTable: QuestionTableReducer,
    tableQuestion: tableQuestionReducer,
    cscq: CSCQReducerNew,
    mscq: MSCQReducerNew,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
    }).concat(logger),
});
